import React from 'react';
import ExerciseItem from './ExerciseItem';

const ExerciseList = ({ exercises, onRemoveExercise, onExerciseMoveUp, onExerciseMoveDown, onSwitchExercise, onClickSuperset, onRemoveExerciseFromSuperset }) => {
  return (
    <div className="w-1/6 bg-white border-r border-gray-200 flex flex-col">
      <div className="p-4 border-b border-gray-200" style={{ height: '73px' }}>
        <h3 className="text-sm font-medium text-gray-900">
          Exercises
        </h3>
      </div>
      
      <div className="flex-1 overflow-y-auto">
        {exercises.length > 0 ? (
          exercises.map((exercise, index) => (
            <ExerciseItem
              key={exercise.id}
              exercise={exercise}
              onRemove={onRemoveExercise}
              index={index}
              length={exercises.length}
              onExerciseMoveUp={onExerciseMoveUp} 
              onExerciseMoveDown={onExerciseMoveDown}
              onSwitchExercise={onSwitchExercise}
              onClickSuperset={onClickSuperset}
              onRemoveExerciseFromSuperset={onRemoveExerciseFromSuperset}
            />
          ))
        ) : (
          <div className="p-4 text-center text-gray-500">
            <p className="text-xs">No exercises added</p>
            <p className="text-xs">Click on "Add Exercise"</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExerciseList;